// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LectureLessonLecturerListResultModel from '../../model/lecture-lesson-lecturer-list-result-model';
import LectureLessonLecturerListResultDTO from '../dto/lecture-lesson-lecturer-list-result-dto';
import dtoSchema from '../schemas/lecture-lesson-lecturer-list-result-schema';
import LectureLessonLecturerModel from '../../model/lecture-lesson-lecturer-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class LectureLessonLecturerListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LectureLessonLecturerListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => LectureLessonLecturerModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: LectureLessonLecturerModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<LectureLessonLecturerListResultDTO>): LectureLessonLecturerListResultModel;
  static toModel(dto: DeepPartial<LectureLessonLecturerListResultDTO> | undefined | null): LectureLessonLecturerListResultModel | undefined;
  static toModel(dto: DeepPartial<LectureLessonLecturerListResultDTO> | undefined | null): LectureLessonLecturerListResultModel | undefined {
    return dto ? new LectureLessonLecturerListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LectureLessonLecturerListResultModel> | LectureLessonLecturerListResultModel): LectureLessonLecturerListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as LectureLessonLecturerListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for LectureLessonLecturerListResultModel, can not map to LectureLessonLecturerListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
